module.exports = __webpack_public_path__ + "static/media/59.8d85f812.jpg";